module.exports = __webpack_public_path__ + "static/media/400101_01.3a2f311a.png";